#import "../../../../core/schema/fragments/CustomerFull.graphql"

query {
  getCustomer {
    ...CustomerFull
  }
}
